import { styled } from '@mui/material/styles';

import { Heading, Tabs, Theme } from '@tgg/ui';

export const StyledWrapper = styled('div')`
    max-width: 85rem;
    padding: 0 3rem;
    margin: 0 auto;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: 1.5rem;
    }
`;

export const StyledMonthHeading = styled(Heading)`
    padding: 0;
    margin: 2rem 0 1rem;
    text-align: center;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        margin: 3.5rem auto 1rem;
    }
`;

export const StyledParagraph = styled('p')`
    margin: 1rem 0 2rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        max-width: 63rem;
        margin: 1.5rem auto 3.5rem;
        text-align: center;
    }
`;

export const StyledAnchor = styled('a')`
    color: #000000;
    text-decoration: underline;
    text-transform: none;
    cursor: pointer;
`;

export const StyledButtonWrapper = styled('div')`
    width: 25rem;
    margin: 3rem auto;
    text-align: center;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        width: 13rem;
        margin: 3rem auto 2rem;

        button {
            font-size: 1.8rem;
        }
    }
    ${({ theme }: { theme: Theme }) => theme.breakpoints.down(330)} {
        width: 18rem;
    }
`;

export const StyledNoClassesParagraph = styled('p')`
    margin: 2rem 0;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        margin: 3.5rem auto;
        text-align: center;
    }
`;

export const StyledTabs = styled(Tabs)`
    margin-inline: 0;
`;
